<template lang="pug">
.page-auth
    Logo.page-auth__logo(
        :height="80"
        :width="183"
    )

    FormAuth
</template>

<script>
import Logo from '@/components/sidebar/Logo.vue';
import FormAuth from '@/components/forms/FormAuth.vue';

export default {
  name: 'PageAuth',

  components: {
    Logo,
    FormAuth,
  },
};
</script>

<style lang="scss" scoped>
.page-auth {
    &__logo {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }
}
</style>
